import React from 'react';
import './App.css';
import DefaultLayout from './components/layouts/DefaultLayout';
import LoginLayout from './components/layouts/LoginLayout';
import { useAuthContext } from './components/AuthProvider';
import { BusinessProvider } from './components/BusinessContext';
import { TillProvider } from './components/tillContext';

// Import the ForgotPassword page
import ForgotPassword from '../src/views/settings/ForgotPassword';
import ResetPassword from '../src/views/auth/ResetPassword2';

import { Routes, Route } from 'react-router-dom';

const App = () => {
  const { loginUser } = useAuthContext();

  return (
    <BusinessProvider>
      <TillProvider>
        {loginUser !== null ? (
          <DefaultLayout />
        ) : (
          <Routes>
            {/* All public (not logged in) routes */}
            <Route path="/*" element={<LoginLayout />} />
            <Route path="/toss/forgotpassword" element={<ForgotPassword />} />
           <Route path="/toss/reset/forgotpassword/resetpassword/:username/:code" element={<ResetPassword />} />
            {/* Add more public routes later */}
          </Routes>
        )}
      </TillProvider>
    </BusinessProvider>
  );
};

export default App;